import React from 'react'

import Header from './Header'
import Navigation from './Navigation'

const HeaderSimple = () => {
  return (
    <Header>
      <Navigation />
    </Header>
  )
}

export default HeaderSimple
